<template>
    <v-layout row wrap class="w-100">
        <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
        >
            <template #activator="{ on }">
                <v-text-field
                    :label="label"
                    prepend-icon="event"
                    readonly
                    :value.sync="vModel"
                    clearable
                    v-on="on"
                    @click:clear="clear()"
                />
            </template>
            <v-date-picker
                locale="en-in"
                :min="minDate"
                :max="maxDate"
                no-title
                :value="vModel"
                @input="dateMenu = false"
                @change="handleChange($event)"
            />
        </v-menu>
    </v-layout>
</template>
<script>
export default {
    name: "DatePickerInput",
    props: {
        label: String,
        minDate: String,
        maxDate: String,
        value: String,
        vModel: String
    },
    data() {
        return {
            dateMenu: false,
        };
    },
    computed: {
        fromDateDisp() {
            return this.vModel;
        },
    },
    methods: {
        handleChange(e) {
            this.$emit("update:vModel", e);
            this.$emit("handleChanges", e);
        },
        clear(e) {
            this.$emit("update:vModel", null);
            this.$emit("handleChanges", e);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/smallComponents/Form/DatePickerInput.vue